export default {
  state: {
    token: '',
    deviceCoding: '',
    phone: '',
    userId: '',
    walletStatus: false,
    pageStatus: '',
    coinNum: 0,// 能量数
    inviteNum: 0,
    totalCoinNum: '',
    name: '',
    certNo: '',
    isHaveHealthCode: '',//是否有健康码：true，有；false，无
    platform:'',
    version:'',
    language:'',
    systemyersion:'',
    statusBarHeight:0

  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },
    setDeviceCoding(state, deviceCoding) {
      state.deviceCoding = deviceCoding
    },
    //原逻辑  userId存储的phone  phone存储的userId
    //现逻辑  userId存储userId  phone存储的phone
    setUserId(state, userId) {
      state.userId = userId
    },
    setPhone(state, phone) {
      state.phone = phone
    },
    setWalletStatus(state, walletStatus) {
      state.walletStatus = walletStatus
    },
    setPageStatus(state, pageStatus) {
      state.pageStatus = pageStatus
    },
    setCoinNum(state, coinNum) {
      state.coinNum = coinNum
    },
    setInviteNum(state, inviteNum) {
      state.inviteNum = inviteNum
    },
    setTotalCoinNum(state, totalCoinNum) {
      state.totalCoinNum = totalCoinNum
    },
    setplatform(state, platform) {
      state.platform = platform
    },
    setversion(state, version) {
      state.version = version
    },
    setlanguage(state, language) {
      state.language = language
    },
    setsystemyersion(state, systemyersion) {
      state.systemyersion = systemyersion
    },
    setStatusBarHeight(state, statusBarHeight) {
      state.statusBarHeight = statusBarHeight
    },
  },
  actions: {
    handLocalSaveLoginInfo({ commit }, { token, deviceCoding, phone ,platform,version,language,systemyersion,statusBarHeight}) {
      return new Promise((resolve, reject) => {
        try {
          if (token) commit('setToken', token)
          if (deviceCoding) commit('setDeviceCoding', deviceCoding)
          if (phone) commit('setPhone', phone)
          if (platform) commit('setplatform', platform)
          if (language) commit('setlanguage', language)
          if (version) commit('setversion', version)
          if (systemyersion) commit('setsystemyersion', systemyersion)
          if (statusBarHeight) commit ('setStatusBarHeight', statusBarHeight)
          resolve('注册成功')
        } catch (e) {
          reject('运行错误');
        }
      })
    },

  }
}
